module.exports = __webpack_public_path__ + "static/img/third1_4_active.fd77e693.png";